import { debounce, filter, Observable, timer } from 'rxjs';

export function doesFormPassValidations(
  activeStep: any,
  options: Partial<{ allowEmptyValues: boolean; debounceTimer: number }> = {}
) {
  return function <T>(source: Observable<T>): Observable<{ valid: boolean; errors: string[] }> {
    return new Observable<{ valid: boolean; errors: string[] }>((subscriber) => {
      return source
        .pipe(
          debounce(() => timer(options.debounceTimer ?? 0)),
          filter((value) => options.allowEmptyValues || !!value)
        )
        .subscribe({
          next: (formValue: any) => {
            if (!activeStep) {
              subscriber.next({ valid: true, errors: [] });
            }

            const validations: any = Object.entries(activeStep?.validation || {});

            // Nothing to validate so this step will alawys be valid
            if (validations.length === 0) {
              subscriber.next({ valid: true, errors: [] });
              return;
            }
            let errorsArray: string[] = [];

            let valid = true;
            validations.forEach(([type, rules]: any) => {
              if (type === 'required') {
                if (rules.value === true && !formValue[activeStep.name]) {
                  valid = false;

                  errorsArray.push(validationMessageMapping[rules.message] || rules.message);

                  return;
                }
              }
            });

            subscriber.next({
              valid,
              errors: errorsArray,
            });
          },
        });
    });
  };
}

const validationMessageMapping: Record<string, string> = {
  'Please choose a date': 'Select a date to continue',
};
